import { createAsyncThunk } from '@reduxjs/toolkit';
import { CALL_UNIQUE_EXTERNAL_ID_PROPERTY } from '../../constants/callObject';
import { callObjectIdSelector } from '../callObject/selectors';
export const fetchRecurringMeetingsList = createAsyncThunk('recurringMeetings/fetchRecurringMeetingsList', (meetingId, thunkAPI) => {
  const callObjectId = callObjectIdSelector(thunkAPI.getState());
  return thunkAPI.extra.callObjectApi.fetchCallObjects({
    after: 0,
    limit: 50,
    query: '',
    meetingId,
    callObjectId,
    meetingExternalUniqueIdPropertyName: CALL_UNIQUE_EXTERNAL_ID_PROPERTY
  }).then(response => response).catch(error => thunkAPI.rejectWithValue(error));
});